import React from 'react'
import {Contact} from '@components/ai'
import SiteFooter from '@components/SiteFooter'
import SiteHeader from '@components/SiteHeader'

type Props = {
  children: React.ReactNode
}

export const AILayout = ({children}: Props) => {
  return (
    <div>
      {/* <Navbar /> */}
      <SiteHeader />
      {children}
      <Contact />
      <SiteFooter />
    </div>
  )
}
